import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

// Define the type for bannerData

const Banner = ({ bannerData }) => {
  const [scrollY, setScrollY] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll effect for the whole banner section
  const scrollProgress = Math.min(scrollY / 400, 1);
  const opacity = Math.max(1 - scrollProgress * 0.7, 0.3);
  const translateY = scrollProgress * 40;
  const scale = 1 - scrollProgress * 0.05;

  return (
    <section className={bannerData.className} style={{
      opacity,
      transition: 'opacity 0.2s',
    }}>
      <div className="container">
        <div className="banner-box">
          <div className="row">
            <div className="col-md-12 mb-5">
              <h6 className="title" style={{
                opacity,
                transform: `translateY(${translateY * 0.5}px) scale(${scale})`,
                transition: 'opacity 0.2s, transform 0.2s',
              }}>{bannerData.headingOne}</h6>
            </div>
            <div className="col-lg-5 col-md-12 col-12">
              <div
                ref={contentRef}
                style={{
                  opacity,
                  transform: `translateY(${translateY}px) scale(${scale})`,
                  transition: 'opacity 0.2s, transform 0.2s',
                }}
              >
                <h2 dangerouslySetInnerHTML={{ __html: bannerData.headingTwo }} />
                <div dangerouslySetInnerHTML={{ __html: bannerData.description }}></div>
                <Link to={`/contact-us`} className="btn btn-orange m-t-50">
                  {bannerData.buttonName}
                </Link>
              </div>
            </div>
          </div>
        </div>
        {bannerData.className === 'slider-img' && <div className="certificate-img">
          <img
            src={`${bannerData.imageUrl}`}
            className="img-fluid"
            alt="Certificate"
          />
        </div>}
      </div>
    </section>
  );
};

export default Banner;
